import { initCampaigns } from "./js/campaigns";
import "./js/navigationsubtabs";
import "./js/pastboardmeetings";
import "./js/navigationtabs";
import "./js/sectiontitleandbutton";
import "./js/sectionvirtualcompetitions";
import "./js/sectionwsapresources";
import "./js/videomodel";
import "./js/externalLinks";
import "./js/sectiondatesanddeadlines";
import "./js/sponsorship-opportunities";
import "./js/section-pdf-and-image-slider";
import "./js/travel-accordion";
import "./js/alumnistoriescard";
import "./js/alumni-stories-slider";
import "./js/sectionscholarshipcards";
import "./js/section-earning-points";
import "./js/guidelines";
import "./js/sectionawardsaccordion";
import "./js/section-awards";
import "./js/accessibility";
import "./js/instaFeed";
import "./js/contentwithvideo";
import "./js/global";
import "./js/newscards";
import "./js/section-members-award";
import "./js/section-members-scholarship";
import "./js/section-recent-publications";
import "./js/section-past-webinars";
import "./js/section-chapter-news";
import "./js/psvaguidelines";
import "./js/competitive-events-listings";
import "./js/breadcrumb-position";

document.addEventListener("DOMContentLoaded", () => {
  // Media starts muted instead of being blocked outright: the previous
  // Promise.reject() here killed all video/audio playback and threw an
  // unhandled rejection on every play() attempt across the site.
  const originalPlay = HTMLMediaElement.prototype.play;
  HTMLMediaElement.prototype.play = function () {
    // Only the first play per element — resuming after a manual unmute
    // must not re-mute.
    if (!this.dataset.bpaAutoMuted) {
      this.dataset.bpaAutoMuted = "1";
      this.muted = true;
    }
    return originalPlay.call(this);
  };
  if (window.AudioContext) {
    const originalContext = window.AudioContext;
    window.AudioContext = function () {
      const ctx = new originalContext();
      ctx.suspend(); // Immediately suspend
      return ctx;
    };
  }
});

document.addEventListener("DOMContentLoaded", () => {
  initCampaigns();
});
